// JavaScript Document

function headerSlider() {

    const masthead                      = document.querySelector('#masthead');
    const swiperContainer               = document.getElementById('header-swiper');
    const pagination                    = document.querySelector('.swiper-pagination');
    const headerSliderAutoplayDelay     = swiperContainer.dataset.autoplay;
    const headerVideos                  = swiperContainer.querySelector('video');
    const slides                        = masthead.querySelectorAll('.swiper-slide');


    function initVideoScene(container, video) {

        // clean up old play-but 
        const oldPlaybut = container.querySelector('.btn-play');

        if (oldPlaybut) {
            oldPlaybut.remove();
        }

        // append new play-but

        appendHtml(container, '<a href="javascript:;" class="btn-play" ><span class="visually-hidden-focusable">Play</a>');

        const playBut =  container.querySelector('.btn-play');


        function removePlaybut(){

            container.querySelector('.btn-play').remove();
        }

        function setPlaybut(state){

            if (state === 'play') {

                playBut.classList.add('pause');

            } else {

                playBut.classList.remove('pause');
            }
        }

        function playVideo(video) {

            if (swiper) {
                swiper.autoplay.stop()
            }
            var isPlaying = video.currentTime > 0 && !video.paused && !video.ended 
                && video.readyState > video.HAVE_CURRENT_DATA;
            if (!isPlaying) {
                setPlaybut('play');
                setTimeout(function(){
                    video.play();
                },100);
            }
        }

        function pauseVideo(video) {
            var isPlaying = video.currentTime > 0 && !video.paused && !video.ended 
                && video.readyState > video.HAVE_CURRENT_DATA;
                setPlaybut('pause');
            if (isPlaying) {
                video.pause();
            }
        }

        playBut.addEventListener('click', function(){

            if (playBut.classList.contains('pause')) {
                pauseVideo(video);
            } else {
                playVideo(video);
            }
        });

        video.addEventListener('ended', function(e) {

            setPlaybut('pause');

        });

        video.addEventListener('pause', function(e) {

            setPlaybut('pause');

        });
        video.addEventListener('playing', function(e) {

            setPlaybut('play');
        });


        return {
        }
    }

    let config = {
        speed: 1900,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
    }
    if (headerSliderAutoplayDelay) {

        config = {
            speed: 1900,
            pagination: {
                el: pagination,
                clickable: true
            },
            autoplay: {
                delay: headerSliderAutoplayDelay,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
        }
    }

    const swiper = new Swiper(swiperContainer, config);


    swiper.on('slideChange', function (e) {

        const oldPlaybut = masthead.querySelector('.btn-play');
        if (oldPlaybut) {
            oldPlaybut.remove();
        }

        let currentVideo = false;

        const activeSlide = slides[e.activeIndex];

        currentVideo = activeSlide.querySelector('video');

        if (currentVideo) {

            var isPlaying = currentVideo.currentTime > 0 && !currentVideo.paused && !currentVideo.ended 
            && currentVideo.readyState > currentVideo.HAVE_CURRENT_DATA;
            if (isPlaying) {
                currentVideo.pause();
            }

            const videoScene = new initVideoScene(masthead, currentVideo);
        }

    });


    const activeSlide = slides[0];
    const initialVideo = activeSlide.querySelector('video');

    if (initialVideo) {

        const videoScene = new initVideoScene(masthead, initialVideo);

    }

    function setParallaxEffect() {

        gsap.fromTo(swiperContainer,{ 
        y: 0,

            // rotationZ: 6,
            //  scale:1.1,
        }, {
        scrollTrigger: {
                start: "top top",
            trigger: swiperContainer,
            scrub: true,

        },
        y: 100,
        // scale:1,
            // rotationZ: 0,
        ease: "none"
        });


    }

    function initialiseMediaPlayer(video) {
        video.controls = false;

        video.addEventListener('volumechange', function(e) {
            // Update the button to be mute/unmute
            if (video.muted) changeButtonType(muteBtn, 'unmute');
            else changeButtonType(muteBtn, 'mute');
        }, false);
        video.addEventListener('ended', function() { this.pause(); }, false);
    }


    setParallaxEffect();

    return false;
}
